import { pathOr, curry, gt } from 'ramda'

export const getFieldError = curry((submitCount: any, touched: any, errors: any, name: any) => {
  const error = pathOr('', name.split('.'), errors)
  const pathName = pathOr('', name.split('.'), touched)
  return (gt(submitCount, 0) && error) || (pathName && error)
})

// Helper function to extract dial code from phone number
export const extractDialCode = (phoneNumber: string): string => {
  if (!phoneNumber) return '+27'
  const trimmed = phoneNumber.trim()
  if (trimmed.startsWith('+')) {
    // Extract dial code (e.g., "+44 1234" -> "+44")
    const match = trimmed.match(/^\+\d+/)
    return match ? match[0] : '+27'
  }
  return '+27'
}
